import { toURL } from "@credit-acceptance/common-frontend";
import type { AnchorHTMLAttributes, FC } from "react";
import { useTranslation } from "react-i18next";

import { cn } from "../../lib/utils";

const PageFooterLink: FC<AnchorHTMLAttributes<HTMLAnchorElement>> = ({ children, href, className, ...properties }) => {
  if (!href) {
    return <span className="underline-offset-2">{children}</span>;
  }
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={cn(
        "underline underline-offset-2 transition-opacity",
        "hover:opacity-80 focus-visible:opacity-80",
        "focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-current",
        className
      )}
      {...properties}
    >
      {children}
    </a>
  );
};

function PageFooter() {
  const { t } = useTranslation();
  let dealerTermsUrl: string | undefined;
  try {
    dealerTermsUrl = toURL("dealerTerms");
  } catch {
    // No-op when running outside the CAPS frame (e.g. local dev).
  }

  const copyright = `© 2012 - ${new Date().getFullYear()} Copyright Credit Acceptance Corporation. All Rights Reserved.`;

  return (
    <footer role="contentinfo" className="bg-primary text-primary-foreground shrink-0 font-sans text-sm">
      <div className="mx-auto px-4 py-2 text-center leading-snug sm:px-6 sm:py-2.5 lg:w-4/5">
        {/* Mobile / tablet: terms + copyright stacked */}
        <p className="m-0 lg:hidden">
          <PageFooterLink href={dealerTermsUrl}>{t("footer.termsLink")}</PageFooterLink> {t("footer.termsText")}
        </p>
        <p className="m-0 lg:hidden">{copyright}</p>

        {/* Desktop: single centered line */}
        <p className="m-0 hidden whitespace-nowrap lg:block">
          <PageFooterLink href={dealerTermsUrl}>{t("footer.termsLink")}</PageFooterLink> {t("footer.termsText")}{" "}
          {copyright}
        </p>
      </div>
    </footer>
  );
}

export default PageFooter;
